import axios from "axios";

export const state = {
    reportpharmacypayments: [],
};

export const getters = {
    reportpharmacypayments: state => state.reportpharmacypayments,
};

export const mutations = {
    setReportPharmacyPayments(reportpharmacypayments, newValue) { state.reportpharmacypayments = newValue},
};

export const actions = {
    fetchReportPharmacyPayments({ commit }) {
        axios.get('/reportpharmacypayments').then(res => {
            commit('setReportPharmacyPayments', res.data.payments)
        })
    },
    filterReportPharmacyPayments({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportpharmacypayments";
        axios.post(url, formData).then((response) => {
            commit('setReportPharmacyPayments', response.data.payments)
        })
    },
};
